<template>
  <!-- <dataTable></dataTable> -->

  <div class="emptyGridMsgSec" v-if="releasedProductList.length == 0">
    <i class="mdi mdi-note-outline"></i>
    <h3>No Record Found</h3>
    <p class="text-muted">
      We didn't find anything to show here, please add new data
    </p>
  </div>
  <!-- v-if="releasedProductList.length > 0" -->
  <div v-if="releasedProductList.length > 0">
    <DataTable
      class="table-responsive"
      v-model:filters="filters"
      :value="releasedProductList"
      paginator
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20, 50]"
      stripedRows
      virtualScroller
      tableStyle="min-width: 50rem"
      responsive
      style="overflow-x: hidden"
    >
      <!-- scrollHeight="400px" -->
      <template #header>
        <div class="row justify-content-between">
          <div class="col-4">
            <BFormInput
              id="inline-form-input-name"
              class="form-control form-control-lg"
              placeholder="Search"
              v-model="filters['global'].value"
            />
          </div>
          <div class="col-4">
            <a
              class="btn btn-block btn-lg btn-gradient-primary"
              style="float: right"
              @click="exportToCSV($event)"
              ><i class="mdi mdi-export"></i> Export</a
            >
          </div>
        </div>
      </template>
      <template #empty> No data found. </template>

      <Column header="Sr. no" headerStyle="width:3rem">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>

      <Column
        v-for="col of columns"
        :key="col.field"
        :field="col.field"
        :header="col.header"
        sortable
      ></Column>
      <Column
        field="prn_created_by"
        header="Latest Version Released By"
        sortable
      >
        <template #body="slotProps">
          <!-- <p >
            {{ slotProps.data.prn_created_by }}
          </p> -->
          <p
            class="user-info-label"
            @click="displayUserDetail($event, slotProps.data.prn_created_by)"
            severity="secondary"
            rounded
          >
            {{ slotProps.data.prn_created_by_user }}
          </p>
        </template>
      </Column>
      <Column field="prn_release_date" header="Last Release Date" sortable>
        <template #body="slotProps">
          {{ formatDateTime(slotProps.data.prn_release_date) }}
        </template>
      </Column>
      <Column field="prd_status" header="Status" sortable>
        <template #body="slotProps">
          <span
            :class="[
              slotProps.data.prd_status == 0
                ? 'badge badge-gradient-danger'
                : 'badge badge-gradient-success',
            ]"
            style="font-size: 0.875rem"
          >
            {{ slotProps.data.prd_status == 1 ? "Active" : "Deactive" }}
          </span>
        </template>
      </Column>
      <Column
        header="New Release"
        v-if="
          auth_store.logged_in_user != undefined &&
          auth_store.logged_in_user.user != null &&
          auth_store.logged_in_user.user.usr_role != null &&
          auth_store.logged_in_user.user.usr_role.url_role_code != 'VWR'
        "
      >
        <template #body="slotProps">
          <a
            v-if="slotProps.data.prd_status == 1"
            class="btn btn-block btn-lg btn-gradient-primary"
            @click="addNewReleaseForProduct(slotProps.data)"
            >+ Add
          </a>
          <p v-if="slotProps.data.prd_status == 0">NA</p>
        </template>
      </Column>
      <Column header="Actions" style="width: 10%; min-width: 8rem">
        <template #body="slotProps">
          <a
            v-if="
              auth_store.logged_in_user != undefined &&
              auth_store.logged_in_user.user != null &&
              auth_store.logged_in_user.user.usr_role != null &&
              auth_store.logged_in_user.user.usr_role.url_role_code != 'RST'
            "
            class="btn-grid-action"
            data-bs-toggle="Click to Download"
            :title="'Download ' + slotProps.data.prn_file_name"
            @click="downloadReleaseNote(slotProps.data)"
          >
            <i class="mdi mdi-arrow-down-bold-circle-outline mdi-24px"></i>
          </a>
          <a class="btn-grid-action" data-bs-toggle="Click to View">
            <i
              class="mdi mdi mdi-eye mdi-24px"
              @click="viewProductReleaseDoc(slotProps.data)"
            ></i>
          </a>
          <!-- <a class="btn-grid-action" title="Click to Delete" v-b-modal.modal-center
                        @click="deleteProductRelease(slotProps.index)">
                        <i class="mdi mdi mdi-delete mdi-24px"></i>
                    </a> -->
          <!-- <a class="btn-grid-action" title="Click to Modify" @click="editProductRelease(slotProps.data)">
                        <i class="mdi mdi-border-color mdi-24px"></i>
                    </a>
                    <a class="btn-grid-action" title="Click to Delete" v-b-modal.modal-center
                        @click="deleteProductRelease(slotProps.index)">
                        <i class="mdi mdi mdi-delete mdi-24px"></i>
                    </a> -->
        </template>
      </Column>
    </DataTable>
  </div>
  <OverlayPanel ref="op">
    <div class="flex flex-column gap-3">
      <div class="flex align-items-center gap-2">
        <img src="../../../assets/images/user-icon.png" style="width: 3rem" />
        <div>
          <span class="font-medium"
            >{{ user.user.usr_user_name }}({{ user.user.url_role_desc }})</span
          >
          <p class="text-sm text-color-secondary" id="userEmail">
            {{ user.user.usr_email }} &nbsp;<span
              ><i
                class="mdi mdi-content-copy mdi-20px"
                @click="copyToClipBoard(user.user.usr_email)"
                v-if="!isTextCopied"
                v-tooltip="{
                  value: 'Click to Copy',
                  showDelay: 1000,
                  hideDelay: 300,
                }"
              ></i>
              <i
                class="mdi mdi-check-all mdi-20px"
                style="color: limegreen"
                v-if="isTextCopied"
                v-tooltip="{
                  value: 'Copied',
                  showDelay: 1000,
                  hideDelay: 300,
                }"
              ></i
            ></span>
          </p>
        </div>
        <!--  -->
      </div>
      <hr style="margin: -0.5rem 0" />
      <div class="flex align-items-center gap-2">
        <a
          :href="
            'mailto:' +
            user.user.usr_email +
            '?subject=your title&body=The message'
          "
        >
          <img
            src="../../../assets/images/outlook-logo.png"
            style="width: 3rem"
          />
          <p class="text-sm">Outlook</p>
        </a>
        <a
          :href="
            'https://teams.microsoft.com/l/chat/0/0?users=' +
            user.user.usr_email
          "
          target="_blank"
        >
          <img
            src="../../../assets/images/teams-logo.png"
            style="width: 3rem"
          />
          <p class="text-sm">Teams</p>
        </a>
      </div>
    </div>
  </OverlayPanel>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useAuthStore } from "@/store/auth_store";
import { useLoading } from "vue-loading-overlay";
import OverlayPanel from "primevue/overlaypanel";

// import Calendar from "primevue/calendar";
const $loading = useLoading();
const auth_store = useAuthStore();
onMounted(() => {});
const content_type = ref("");
const op = ref();
const isTextCopied = ref(false);
const showUserInfo = ref(false);
const user = ref({});

const columns = ref([
  { field: "prd_name", header: "Product Name" },
  { field: "prd_product_line", header: "Product Line" },
  // { field: "prn_created_by", header: "Latest Version Released By" },
  { field: "prn_firmware", header: "Latest Firmware" },
  { field: "prn_version", header: "Latest Version" },
  // { field: 'prn_release_date', header: 'Last Released On' },
]);

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const viewProductReleaseDoc = (objselectedItem) => {
  auth_store.selectedProduct = objselectedItem;
  router.push({ name: "view-product" });
};

const exportToCSV = () => {
  let loading = $loading.show();
  axios
    .get("/export_release_note_detail")
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Product_Release_details.csv");
      document.body.appendChild(link);
      link.click();
      loading.hide();
    })
    .catch((err) => {
      loading.hide();
      toast(err.response.data.detail, {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    });
};

const downloadReleaseNote = (objselectedItem) => {
  let loading = $loading.show();
  const obj_file = {
    file_path: objselectedItem.prn_file_location,
    file_name: objselectedItem.prn_file_name,
    prd_name: objselectedItem.prd_name,
    file_type: "versions",
  };

  axios
    .post("/download_file", obj_file, { responseType: "blob" })
    .then((res) => {
      if (res.data != undefined && res.data != null) {
        const file_type = objselectedItem.prn_file_name.split(".")[1];

        if (file_type == "pdf") content_type.value = "application/pdf";
        else if (file_type == "docx")
          content_type.value =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        else if (file_type == "doc") content_type.value = "application/msword";
        else if (file_type == "xlsx")
          content_type.value =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        else if (file_type == "xls")
          content_type.value = "application/vnd.ms-excel";
        else content_type.value = "application/text";

        const blob = new Blob([res.data], {
          type: content_type.value,
        }); //"application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = objselectedItem.prn_file_name;
        link.click();
        loading.hide();
      }
    })
    .catch((err) => {
      loading.hide();
      toast("File not Found.", {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    });
};

const displayUserDetail = (event, usr_id) => {
  op.value.toggle(event);

  axios
    .get("/fetch_user_by_usr_id?usr_id=" + usr_id)
    .then((res) => {
      showUserInfo.value = true;
      user.value = res.data;
    })
    .catch((err) => {
      showUserInfo.value = false;
    });
};

const copyToClipBoard = (strData) => {
  isTextCopied.value = false;
  // Copy the text inside the text field
  navigator.clipboard.writeText(strData);

  isTextCopied.value = true;
  resetStatus();
};

function resetStatus() {
  setTimeout(() => {
    isTextCopied.value = false;
  }, 5000);
}
</script>

<script>
/* eslint-disable */
import { toast } from "vue3-toastify";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import { format } from "date-fns";
import axios from "axios";
import router from "@/router";

const modalTitle = "Delete Confirmation";
const modalMessage = "Are you sure you want to delete the product release?";
const selectedIndex = null;

export default {
  name: "RelasedProductList",
  props: {
    releasedProductList: [],
  },
  data() {
    return {
      modalMessage,
      modalTitle,
      selectedIndex,
    };
  },
  components: {
    DataTable,
    Column,
  },
  methods: {
    editProductRelease(objselectedItem) {
      this.$emit("selected-data", objselectedItem);
    },
    deleteProductRelease(index) {
      this.$modalConfig = {
        id: "modal-center",
        title: "Delete Confirmation",
        message:
          "Are you sure you want to delete the product releasekguwute8te78f6v72vr?",
      };

      toast("Data deleted successfully !", {
        autoClose: 2000,
        theme: "colored",
        type: "success",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    },
    formatDateTime(value) {
      if (value != null) return format(value, "MMM dd, yyyy").toLocaleString();
      return "";
    },
    addNewReleaseForProduct(objselectedItem) {
      this.$emit("prd-for-new_release", objselectedItem);
    },
  },
};
</script>
